import { useUserContext } from "@/context/user.context";
import type { UserCapability } from "@/types/user";

export const useUserHasCapability = (capability: UserCapability) => {
  const { user } = useUserContext();

  return user?.capabilities.includes(capability) ?? false;
};
